export default "__VITE_ASSET__BaoiN_a0__"